const FooterNewsletter = () => {
  const $body = $('body')
  // Formulaire générique
  const $mainForm = $body.find('main form.newsletter')
  const submitId = 'btn-nl-iraiser-submit'
  // Footer
  const $container = $body.find('.nl-form__container')
  const submitToRemove = 'opacity-50 cursor-not-allowed'
  if ($container.length) {
    const enableSubmit = ($target) => {
      $target.removeClass(submitToRemove)
        .removeAttr('disabled')
      disableMainForm()
    }
    const disableSubmit = ($target) => {
      $target.addClass(submitToRemove)
        .attr('disabled', 'disabled')
      enableMainForm()
    }
    const disableMainForm = () => {
      if($mainForm.length) {
        $mainForm.each((_, el) => {
          const $el = $(el)
          $el.find('button[type="submit"]').removeAttr('id')
        })
      }
    }
    const enableMainForm = () => {
      if($mainForm.length) {
        $mainForm.each((_, el) => {
          const $el = $(el)
          $el.find('button[type="submit"]').attr('id', submitId)
        })
      }
    }
    // Activation bouton submit si cta coché
    $container.find('input#legals-cta').click((evt) => {
      const $el = $(evt.currentTarget)
      const $submitButton = $container.find('button[type="submit"]')
      if ($el.prop('checked') === true) {
        enableSubmit($submitButton)
      } else {
        disableSubmit($submitButton)
      }
    })
    // Par sécurité on check si l'autre form n'est pas rempli
    if($mainForm.length) {
      $mainForm.each((_, el) => {
        const $el = $(el)
        $el.find('input[type="email"]').on('focus', () => {
          enableMainForm()
          $container.find('input#legals-cta').prop('checked', false)
        })
      })
    }
  }
}

export default FooterNewsletter



// WEBPACK FOOTER //
// ./scripts/components/FooterNewsletter.js